<template>
  <v-dialog
    v-model="showModal"
    max-width="700"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-devices
        </v-icon> Create DigiBoard Type
      </h2>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container class="my-container-style">
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="typeName"
                :rules="[(v) => !!v || 'This field is required']"
                label="Type Name*"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="digiBoardPosition"
                menu-props="auto"
                :items="digiBoardPositions"
                item-text="id"
                item-value="value"
                label="DigiBoard Position*"
                :rules="[(v) => !!v || 'This field is required']"
                single-line
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="digiBoardPlacement"
                menu-props="auto"
                :items="digiBoardPlacements"
                item-text="id"
                item-value="value"
                label="DigiBoard Placement*"
                :rules="[(v) => !!v || 'This field is required']"
                single-line
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-select
                v-model="displayType"
                menu-props="auto"
                :items="displayTypes"
                item-text="id"
                item-value="value"
                label="Display Type*"
                :rules="[(v) => !!v || 'This field is required']"
                single-line
              />
            </v-col>
          </v-row>
          <p class="text-sm-left">
            *Indicates required field
          </p>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createDigiBoardType()"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'CreateDigiBoardType',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        typeName: '',
        digiBoardPosition: '',
        digiBoardPositions: [{ id: 'Indoor', value: 'indoor' }, { id: 'Outdoor', value: 'outdoor' }],
        digiBoardPlacement: '',
        digiBoardPlacements: [{ id: 'Wall Mounted', value: 'wall_mounted' }, { id: 'Hanging', value: 'hanging' }, { id: 'Floor Standing', value: 'floor_standing' }],
        displayType: '',
        displayTypes: [{ id: 'LED', value: 'led' }, { id: 'LCD', value: 'lcd' }],
        loading: false,
        isFormValid: false,
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async createDigiBoardType () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('digiboards/createDigiBoardType', {
          name: this.typeName,
          position: this.digiBoardPosition,
          placement: this.digiBoardPlacement,
          display_type: this.displayType,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'DigiBoard type created successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('success');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        }); ;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 55px;
  margin-right: 5px;
}
.my-container-style {
    padding-top: 24px;
}
</style>
